<template>
  <div style="width:100%;">
    <div class="topbar">
      <a
        :href="'/' + Language + '/'"
        class="logoBox"
      >
        <img src="../assets/img/eurotrader_logo_rgb_white.svg" />
      </a>
      <div
        v-if="!$auth.check()"
        class="regButtons"
      >
        <div class="action">
          <router-link
            class="button is-primary main login is-pulled-right"
            :to="'/' + Language + '/login'"
          >{{ $t('login').tUpper() }}</router-link>
        </div>
        <div class="action">
          <router-link
            class="button is-primary main register is-pulled-right"
            :to="'/' + Language + '/register'"
          >{{ $t('register').tUpper() }}</router-link>
        </div>
      </div>
    </div>

    <div
      id="webterminal"
      style="width:calc(100vw - 20px); height: calc(100vh - 68px); z-index: 2; position:relative"
    ></div>

    <div style='position:absolute; left:50%; top:50%; transform: translate(-50%, -50%); z-index:1'>
      {{ $t('content_ad_blocker_notice') }}
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    let mt5script = document.createElement('script')
    mt5script.addEventListener('load', function () {
      window.MetaTraderWebTerminal('webterminal', {
        version: 5,
        servers: ['EurotradeSA-Server-1'],
        server: 'EurotradeSA-Server-1',
        utmSource: 'www.eurotrader.com',
        startMode: 'login',
        language: 'en',
        colorScheme: 'black_on_white',
      })
    })
    mt5script.src = 'https://metatraderweb.app/trade/widget.js'
    document.head.appendChild(mt5script)

     setTimeout(() => {
      let el = document.getElementById('hubspot-messages-iframe-container')
      el.setAttribute('style', 'display:none !important')
    }, 2000)
  },
}
</script>
<style lang="scss">
.topbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-content: center;
  background-color: #6826f4;
  @media screen and (max-width: 1024px) {
    flex-direction: column;
    height: auto;
  }
  .logoBox {
    height: 100%;
    background-color: #10182a;
    width: 196px;
    display: flex;
    align-items: center;
    @media screen and (max-width: 1024px) {
      height: 60px;
      width: 100%;
      justify-content: center;
    }
    img {
      max-height: 35px;
      margin: 5px 0px;
      padding-left: 20px;
      max-width: 176px;
      @media screen and (max-width: 1024px) {
        padding-left: 0;
      }
    }
  }
  .action {
    padding: 0 10px 0 0;
    height: 100%;
    line-height: 80px;
    display: flex;
    align-items: center;
  }
  .login {
    border: 0;
    color: #10182a;
    background: #3bed83 0% 0% no-repeat padding-box;
    border-radius: 23px;
    width: 117px;
    height: 32px;
    font: normal normal 600 12px/14px Roboto;
    letter-spacing: 0px;
    margin-right: 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    &:hover {
      background-color: #3bed83;
      color: #10182a;
    }
  }
  .register {
    border: 0;
    color: white;
    background: #e04ef8 0% 0% no-repeat padding-box;
    border-radius: 23px;
    width: 117px;
    height: 32px;
    font: normal normal 600 12px/14px Roboto;
    letter-spacing: 0px;
    margin-right: 10px;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    @media screen and (max-width: 1024px) {
      margin-right: 0;
    }
  }
}

.regButtons {
  display: flex;
  margin-right: 10px;
  @media screen and (max-width: 1024px) {
    margin-right: 0;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 16px;
  }
}

#hubspot-messages-iframe-container{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// MT5WebClient.vue?31ec744e